import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { LinkButton, UIText1, UIText2 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { TOfferFromHistoryData } from '../../../../../types/offerHistory';
import { Price, Error, Loading, DeactivatedLabel, KeyValTable, AuthError } from '../../commonComponents';
import { OfferGallery } from '../OfferGallery';

export interface IOfferFromHistoryProps {
  offer?: TOfferFromHistoryData | null;
  deactivatedTitle: string | null;
  authErrorTitle: string;
  isLoading?: boolean;
  isError?: boolean;
  isAuthError?: boolean;
  onAuthErrorClick(): void;
  onOfferShow(): void;
  onGalleryScroll(): void;
  onGalleryClick(): void;
  onRedirectToOfferClick(): void;
}

export const OfferFromHistory: React.FC<IOfferFromHistoryProps> = props => {
  const {
    offer,
    isLoading,
    isError,
    isAuthError,
    deactivatedTitle,
    authErrorTitle,
    onOfferShow,
    onGalleryScroll,
    onGalleryClick,
    onRedirectToOfferClick,
    onAuthErrorClick,
  } = props;

  const information = React.useMemo(() => {
    if (isLoading) {
      return <Loading height={300} />;
    }

    if (isAuthError) {
      return <AuthError title={authErrorTitle} onClick={onAuthErrorClick} />;
    }

    if (isError) {
      return <Error />;
    }

    return null;
  }, [isAuthError, isError, isLoading, onAuthErrorClick]);

  return (
    <>
      {offer && !isError && !isAuthError && (
        <ActionAfterViewObserver callback={onOfferShow} triggerOnce={false} wrapper={false}>
          <div data-testid="offers_history_full_offer">
            <div className={styles['gallery']}>
              <OfferGallery images={offer.images} onScroll={onGalleryScroll} onClick={onGalleryClick} />
            </div>

            <div className={styles['price']}>
              <Price size="M" diff={offer.prices.priceDiff} subprice={offer.prices.priceSqm}>
                {offer.prices.price}
              </Price>
              {deactivatedTitle && <DeactivatedLabel title={deactivatedTitle} />}
            </div>
            <div className={styles['title']}>
              <UIText1>{offer.title}</UIText1>
            </div>
            <div className={styles['address']}>
              <UIText2 color="text-secondary-default">{offer.address}</UIText2>
            </div>
            {offer.kpName && (
              <div className={styles['kp']}>
                <UIText1>{offer.kpName}</UIText1>
              </div>
            )}

            {!!offer.dealConditions && (
              <KeyValTable
                size="M"
                className={styles['features']}
                table={offer.dealConditions}
                title="Условия сделки"
              />
            )}

            <KeyValTable
              size="M"
              className={styles['features']}
              table={offer.features}
              title={offer.dealConditions ? 'Общая информация' : undefined}
            />

            {offer.link && (
              <div className={styles['redirect-btn']}>
                <LinkButton
                  size="XS"
                  href={offer.link}
                  target="_blank"
                  rel="noreferrer"
                  theme="fill_secondary"
                  onClick={onRedirectToOfferClick}
                >
                  Посмотреть объявление
                </LinkButton>
              </div>
            )}
          </div>
        </ActionAfterViewObserver>
      )}
      {information}
    </>
  );
};
